import { StoragePage } from './types'

export const storagePage: StoragePage = {
    table_id: 0,
    table_move_id: 0,
    zones: [],
    matrix_items: [],
    items_to_move: []
}
